import script from "./BillAdjustmentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BillAdjustmentForm.vue?vue&type=script&setup=true&lang=js"

import "./BillAdjustmentForm.vue?vue&type=style&index=0&id=554f82ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554f82ae"]])

export default __exports__